<template>
  <nav>
    <ol role="list" class="flex items-center text-text-md px-4 py-2 bg-gray-100 rounded-sm">
      <li
        v-for="(item, index) in items" :key="`${item.label}_${index}`" class="flex items-center"
        :aria-current="isActive(item) ? 'page' : false"
        role="listitem"
      >
        <router-link
          v-if="item.to && !isActive(item)"
          :to="item.to"
          @click="handleClick(item)"
          class="text-blue-400 hover:text-blue-600 flex items-center"
        >
          <span v-if="item.icon" class="material-icons-round mr-1 text-base">{{ item.icon }}</span>
          <span class="hover:underline">{{ item.label }}</span>
        </router-link>
        <span
          v-else
          :class="{ 'text-gray-900': !item.to || isActive(item) }"
          class="flex items-center"
        >
          <span v-if="item.icon" class="material-icons-round mr-1 text-base">{{ item.icon }}</span>
          {{ item.label }}
        </span>
        <span v-if="!isLastItem(index)" aria-hidden="true" class="px-2 text-gray-400">/</span>
      </li>
    </ol>
  </nav>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router'

export interface BreadcrumbItem {
  label: string
  to?: {
    name: string
    params?: Record<string, string | string[]>
    query?: Record<string, string | string[]>
  } | string
  icon?: string
}

const props = defineProps<{
  items: BreadcrumbItem[]
}>()

const route = useRoute()

const isLastItem = (index: number) => {
  return index === props.items.length - 1
}

const isActive = (item: BreadcrumbItem) => {
  if (!item.to) return false

  if (typeof item.to === 'string') {
    return route.path === item.to
  }

  return item.to.name === route.name
}

const emit = defineEmits<{
  (e: 'click', item: BreadcrumbItem): void
}>()

const handleClick = (item: BreadcrumbItem) => {
  emit('click', item)
}
</script>

